import { MobileHistoryTransactionClockIconContainerStyled } from './styled/MobileHistoryTransactionStyled';
import BinIcon from '../../../../../components/icon/Icon';
import amountFormat from '../../../../../utils/amountFormat';
import {
    STATE_TX,
    TRANSACTION_SIDES,
} from '../../../../../modules/Account/components/TransactionHistory/transactionHistoryConstants';
import classNames from 'classnames';
import { useLangContext } from '../../../../../providers/LangProvider/LangProviderContext';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountSelectedHistoryInfoAction } from '../../../../../modules/Account/accountActions';
import { MOBILE_HISTORY_INFO_TYPES } from '../../mobileHistoryConstants';
import MobileHistoryTransactionIcon from '../MobileHistoryTransactionIcon';
import {
    MobileHistoryRowAmountStyled,
    MobileHistoryRowIconContainerStyled,
    MobileHistoryRowStyled,
} from '../../styled/MobileHistoryRowStyled';
import { IMobileHistoryTransactionRow } from '../../mobileHistory.t';
import { getIsUserSelectedAccountTypeLive } from '../../../../../app/appSelectors';
import { locationSlice } from '../../../../../modules/Location/locationReducer';
import { LOCATION_NAMES } from '../../../../../modules/Location/locationConstants';

interface IMobileHistoryTransactionRowProps {
    item: IMobileHistoryTransactionRow,
}

function MobileHistoryTransactionRow(props: IMobileHistoryTransactionRowProps) {
    const { item } = props;
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const isUserSelectedAccountTypeLive = useSelector(getIsUserSelectedAccountTypeLive);

    const amount = item.side === TRANSACTION_SIDES.UP ? +item.amount : -item.amount;

    const handleRowClick = useCallback(() => {
        dispatch(setAccountSelectedHistoryInfoAction({
            info: { transaction: item },
            type: MOBILE_HISTORY_INFO_TYPES.TRANSACTION,
        }));
        dispatch(locationSlice.actions.openLocationAction({
            name: LOCATION_NAMES.HISTORY_INFO,
            searchParams: { type: MOBILE_HISTORY_INFO_TYPES.TRANSACTION, id: item.uuid },
        }));
    }, [dispatch, item]);

    return (
        <MobileHistoryRowStyled onClick={handleRowClick}>
            <MobileHistoryRowIconContainerStyled>
                <MobileHistoryTransactionIcon item={item}/>
                {
                    item.state === STATE_TX.PROCESSING &&
                    <MobileHistoryTransactionClockIconContainerStyled>
                        <BinIcon name='IcClockBlackCircle'/>
                    </MobileHistoryTransactionClockIconContainerStyled>
                }
                {
                    item.state === STATE_TX.ERROR &&
                    <MobileHistoryTransactionClockIconContainerStyled>
                        <BinIcon name='IcClear' style={{ color: 'var(--color-red)' }}/>
                    </MobileHistoryTransactionClockIconContainerStyled>
                }
                {
                    item.state === STATE_TX.CANCELED &&
                    <MobileHistoryTransactionClockIconContainerStyled>
                        <BinIcon name='IcCircleSlashed' style={{ fill: 'var(--color-red)' }}/>
                    </MobileHistoryTransactionClockIconContainerStyled>
                }
            </MobileHistoryRowIconContainerStyled>
            <div className='flex-1 overflow-hidden 2'>
                <div className='f16 text-truncate'>
                    {getLangPath(
                        `lite_version.history.transaction.title.${(item.type === 'respawn' && !isUserSelectedAccountTypeLive) ? 'refill' : item.type}`,
                        { payment_name: item.payment_name },
                        { emptyDefault: true },
                    ) || item.type}
                </div>
                <div className='color-white-60'>{item.payment_name}</div>
            </div>
            <div className='ms-2 text-right'>
                <MobileHistoryRowAmountStyled className={classNames({
                    'negative': parseFloat(item.amount) <= 0,
                    'positive': parseFloat(item.amount) > 0,
                    'secondary': ([STATE_TX.PROCESSING, STATE_TX.ERROR, STATE_TX.CANCELED] as readonly string[]).includes(item.state),
                })}>
                    {amountFormat(amount, 2, '$')}
                </MobileHistoryRowAmountStyled>
                <div className='color-white-60'>{item.formattedDate}</div>
            </div>
        </MobileHistoryRowStyled>
    );
}

export default MobileHistoryTransactionRow;
